export function getError(pVideoInfo, pError = null, pName = "") {
  let error = null;

  //Теоретично для STV це можуть бути свої методи
  let methods = [getLoaderError, getPlaybackError, getDRMError, getEPGError, getCCIError, getOtherError];

  for (let i = 0; i < methods.length; i++) {
    error = methods[i].call(null, pVideoInfo, pError, pName = "");
    if (error) break;
  }

  return error;
}

// Помилка завантаження відео
function getLoaderError(pVideoInfo, pError = null, pName = "") {
  if (pError && pError.type) {
    switch (pError.type) {
      case 'networkError':
      case 'streamError':
        return {code: "loader", info: pError.code};
    }
  }

  return null;
}

//Помилка відтворення відео
function getPlaybackError(pVideoInfo, pError = null, pName = "") {
  if (pError && pError.type) {
    switch (pError.type) {
      case 'playbackError':
        if (pError.code === "contentIsBlocked") return null;
      case 'internalError':
      case 'parsingError':
        return {code: "playback", info: pError.code};
    }
  }

  return null;
}

//Помилка, повʼязана з DRM
function getDRMError(pVideoInfo, pError = null, pName = "") {
  if (pError && pError.type) {
    switch (pError.type) {
      case 'drmError':
        return {code: "drm", info: pError.code};
    }
  }

  return null;
}

//Помилка, повʼязана з відображенням EPG
function getEPGError(pVideoInfo, pError = null, pName = "") {
  if (pError && pError.type && pName === "epg:error") {
    return {code: "epg", info: pError.code};
  }
  return null;
}

//Помилка одночасного доступу
function getCCIError(pVideoInfo, pError = null, pName = "") {
  if (pError && pError.type) {
    switch (pError.type) {
      case 'playbackError':
        if (pError.code === "contentIsBlocked") return {code: "connections_limit", info: pError.code};
    }
  }

  return null;
}

//Інші помилки, де користувач бачить чорний екран
function getOtherError(pVideoInfo, pError = null, pName = "") {
  if (pError && pError.type && pError.code) return {code: "other", info: pError.code};
  return null;
}
